<template>
  <div v-if="mdetailShow">
    <div>
      <div id="addUrl" v-if="newUrlSize">
        <span id="addUrlTittle">Urls to add</span>
        <span>{{ this.newToAdd.product_domains }}</span>
        <span
          v-for="(item, item_index) in this.newToAdd.product_domains"
          :key="item_index"
        >
          <li v-for="(url, url_index) in item.domain_urls" :key="url_index">
            {{ url.url }}
          </li>
        </span>
        <v-btn @click="clean"> Clean Urls </v-btn>
        <v-btn @click="saveUrls(product['product_info'].product_id)">
          Save Urls
        </v-btn>
      </div>

      <span v-if="this.returnProductId(product) > 0">
        <v-btn
          ref="deleteButton"
          id="deleteButton"
          :disabled="checkedUrls.length == 0"
          :hidden="checkedUrls.length == 0"
          @click="deleteDialog = true"
          class="ex-btn ml-1 custom_button ex-primary-btn"
          text
        >
          Delete urls
        </v-btn>
      </span>
      <span v-if="this.returnProductId(product) == 0">
        <v-btn
          ref="saveButton"
          :disabled="this.enableSave()"
          @click="ProductSave()"
          class="ex-btn ml-1 custom_button ex-primary-btn"
          text
        >
          Save
        </v-btn>
      </span>

      <v-dialog v-model="deleteDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Deleting, are you sure?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            :ripple="false"
            class="ex-btn ex-primary-btn text--white"
            @click="deleteDialog = false"
          >
            No
          </v-btn>
          <v-btn
            text
            :ripple="false"
            class="ex-btn ex-primary-btn text--white"
            @click="DeleteUrls(checkedUrls, product['product_info'].product_id)"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <span
        v-if="
          (this.productClient.length == 0) &
          (this.returnProductId(product) == 0)
        "
        >Please select a client</span
      >
      <span v-for="(item, index) in this.productClient" :key="index">
        -{{ item.text }}
      </span>
      <span>
        <span
          v-if="
            product.product_info.product_id > 0 &&
            product['product_domains'].length &&
            this.productClient.length
          "
        >
          <v-btn
            :disabled="this.productClient.length == 0"
            @click="SaveAllClients(product)"
          >
            Save Clients
          </v-btn>
          <!--  <li v-for="client in product['product_clients']"> {{client['client_name']}}</li>-->
        </span>
      </span>
      <span ref="save"></span>
      <div
        class="domain_table"
        v-for="(domain) in sortedArray"
        :key="domain.domain_id"
      >
        <div class="inner">
          <h2 class="domain_title">{{ domain["domain_name"] || "_" }}</h2>
          <label class="i-checkbox">
            <input
              :disabled="product.product_clients.map(x => x.my_seller).includes(`${domain.domain_urls[0].sellers[0].seller_id}`)"
              :id="domain.domain_id"
              type="checkbox"
              class="ma-0 custom-checkbox"
              ref="childCheckboxSeller"
              :checked="selectedAllFlag"
              @change="
                selectDomain(
                  $event,
                  domain['domain_urls'],
                  product['product_info'].product_id
                )
              "
            />
            <!-- outside checkbox -->
            <span class="checkmark"></span>
          </label>
        </div>
        <div
          class="domain_section"
          v-for="(link, indx) in domain['domain_urls']"
          :key="indx"
        >
          <div class="ex-data-table total-product-data-table mb-2">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div class="domain_row_header">
                    <div class="domain_row_header_variation">
                      <span class="link_text">{{
                        link["variation"]["variation_text"] || "_"
                      }}</span>
                    </div>
                    <div class="domain_row_header_url">
                      <v-btn
                        @click.native.stop="copyLink"
                        fab
                        dark
                        x-small
                        title="Copy the link"
                        class="mr-2"
                      >
                        <v-icon small>assignment</v-icon>
                      </v-btn>
                      <span class="link_text">{{ link.url || "_" }}</span>
                    </div>
                    <div class="domain_row_header_checkbox">
                      <label class="i-checkbox float-right">
                        <input
                          type="checkbox"
                          ref="childCheckbox"
                          class="ma-0 custom-checkbox track_checkbox"
                          :value="link"
                          v-model="checkedUrls"
                          :disabled="product.product_clients.map(x => x.my_seller).includes(`${link.sellers[0].seller_id}`)"
                          @change="selectSingleUrl( $event.target.checked, link, product['product_info'].product_id)"
                        />
                        <!-- inside checkboxes -->
                        <span class="checkmark"></span>
                      </label>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ProductDetailsTableSellers
                    :selected="selected"
                    :sellers="link.sellers"
                    :product-url-id="link.url_id"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { productDetailsBus } from "@/helpers/buses.js";
import Table from "./Table";
import ProductDetailsTableSellers from "./ProductDetailsTableSellers";
export default {
  name: "ProductDetailsTable",
  components: { Table, ProductDetailsTableSellers },

  computed: {
    sortedArray: function () {
      function compare(a, b) {
        if (a.domain_name < b.domain_name) return -1;
        if (a.domain_name > b.domain_name) return 1;
        return 0;
      }

      return this.product["product_domains"].sort(compare);
    },
    newUrlSize() {
      if (typeof this.newToAdd.product_domains !== "undefined") {
        if (this.newToAdd.product_domains.length > 0) {
          return true;
        }
      } else return false;
    },
    newToAdd() {
      return this.$store.state.productModule.newToAdd;
    },
    tableData() {
      return this.$store.state.productModule.urlsContainer;
    },
    productClient() {
      return this.$store.state.productModule.productClients;
    },

    mdetailShow() {
      return this.$store.state.productModule.DetailsShow;
    },
  },
  props: {
    selected: {
      type: Array,
      default: null,
    },
    product: {
      type: [Object, Array],
      default: null,
    },
    productsData: {
      type: [Object, Array],
      default: null,
    },
    productInfo: {
      type: [Object, Array],
      default: null,
    },
  },
  data: () => ({
    deleteDialog: false,
    checkedUrls: [],
    rowsPerPageItems: [50, 100, 200, 400],
    pagination: {
      rowsPerPage: 200,
    },
    selectedAllFlag: false,
  }),
  methods: {
    parentProduct(id) {
      this.$emit("parentProduct", id);
    },

    mychange($event, domains) {
      console.log(domains);
    },

    SaveAllClients(product) {
      let allClients = product["product_clients"];
      let productclients = this.productClient;
      for (let i = 0; i < productclients.length; i++) {
        let obj = allClients.find(
          (o) => o.client_name === productclients[i].text
        );
        if (obj) {
          this.$store.commit("productModule/SET_PRODUCT_CLIENT", i);
        }
        console.log("conflict", obj);
      }

      let data = {
        product_id: product.product_info.product_id,
        clients: productclients,
      };
      console.log("data", data);

      //  console.log("allclients", allClients);
      // alert(productclients.length)
      if (productclients.length > 0) {
        this.$store
          .dispatch("productModule/saveProductClient", data)
          .then((res) => {
            if (!res.data.error) {
              // this.deleteDuplicateProduct(data.conflict)
            }
          });
      } else {
        alert("There are no clients to insert!");
      }
    },
    saveUrls(product_id) {
      // alert(product_id)

      let payload = {
        product_id: product_id,
        urls: this.newToAdd,
      };

      this.$store
        .dispatch("productModule/AddUrlToProduct", payload)
        .then((res) => {
          if (res.data.payload.status == "success") {
            this.$store.commit("productModule/NEW_ADD", {});
            this.$emit("parentProduct", product_id);
          }
        })

        .catch((error) => {
          //catch the error here
          alert(error);
        });
    },
    clean() {
      this.$store.commit("productModule/NEW_ADD", {});
    },
    returnProductId(product) {
      if (product["product_info"].product_id > 0)
        return product["product_info"].product_id;
      else return 0;
    },
    addBrand() {
      this.$store.commit("productModule/ADD_BRAND", this.Pbrand);
    },
    ProductSave() {
      console.log("Save", this.tableData);
      let clients = {};
      let product_pending = {};
      let product_info = {};
      let payload = {};
      Object.assign(clients, this.productClient);
      Object.assign(product_pending, this.tableData.product_domains);
      Object.assign(product_info, this.tableData.product_info);
      Object.assign(payload, { product_pending, product_info, clients });
      // console.log('tabledata',this.tableData.product_info)

      this.$store
        .dispatch("productModule/saveNewProduct", payload)
        .then((res) => {
          alert(res.data.payload.status);
          if (res.data.payload.status == "success") {
            this.$store.commit("productModule/ADD_NAME", "");
            this.$store.commit("productModule/ADD_BRAND", "");
            //  this.$store.commit("productModule/SET_URLS", {});
            this.$store.commit("productModule/ADD_PRODUCT_CLIENT", [
              { text: "", value: "0" },
            ]);
            this.$store.commit("productModule/SET_SHOW", false);
            console.log("parent", this.$parent.$props); //selectedProductList);
            // this.$parent.selectedProductList=null
          }
        })

        .catch((error) => {
          //catch the error here
          alert(error);
        });
    },
    enableSave() {
      // alert(this.$store.state.productModule.urlsContainer.product_info
      //   .product_name)
      if (
        typeof this.$store.state.productModule.urlsContainer.product_info !==
          "undefined" &&
        this.$store.state.productModule.urlsContainer.product_info
          .product_name !== "" &&
        this.$store.state.productModule.urlsContainer.product_info
          .product_name != null &&
        this.productClient.length > 0
      ) {
        return false;
      } else return true;
    },
    copyLink({ target }) {
      const link = target
        .closest(".domain_row_header_url")
        .querySelector(".link_text").innerText;
      const tempElement = document.createElement("input");
      tempElement.value = link;
      document.getElementsByTagName("body")[0].append(tempElement);
      tempElement.select();
      document.execCommand("copy");
      tempElement.remove();
    },
    findProductIndex() {
      return this.productsData.findIndex(
        (product) => product.product_id === this.productInfo.product_id
      );
    },
    getPrevProductId() {
      const prevIndex = this.findProductIndex() - 1;
      if (prevIndex < 0) return false;
      return this.productsData[prevIndex].product_id;
    },
    getNextProductId() {
      const nextIndex = this.findProductIndex() + 1;
      if (nextIndex === this.productsData.length) return false;
      return this.productsData[nextIndex].product_id;
    },
    handlePrevBtn(prevBtn) {
      this.setBtnDisable(prevBtn, this.getPrevProductId);
      if (this.getPrevProductId()) {
        this.$emit("showPreviousProduct", this.getPrevProductId());
      }
    },
    handleNextBtn(nextBtn) {
      this.setBtnDisable(nextBtn, this.getNextProductId);
      if (this.getNextProductId()) {
        this.$emit("showNextProduct", this.getNextProductId());
      }
    },
    setBtnDisable(btn, getProductId) {
      if (!getProductId()) {
        btn.disabled = true;
        btn.className = `${btn.className} v-btn--disabled`;
      }
    },
    updateFooterButtonsListeners(remove = false) {
      const prevBtn = document.querySelector(
        ".v-data-footer__icons-before button"
      );
      const nextBtn = document.querySelector(
        ".v-data-footer__icons-after button"
      );
      if (!prevBtn && !nextBtn) {
        return;
      }
      if (remove) {
        prevBtn.removeEventListener("click", this.handlePrevBtn, false);
        prevBtn.removeEventListener("click", this.handlePrevBtn, true);
        nextBtn.removeEventListener("click", this.handleNextBtn, false);
        nextBtn.removeEventListener("click", this.handleNextBtn, true);
        return;
      }

      prevBtn.disabled = false;
      nextBtn.disabled = false;
      prevBtn.className = prevBtn.className.replace("v-btn--disabled", "");
      nextBtn.className = nextBtn.className.replace("v-btn--disabled", "");
      this.setBtnDisable(prevBtn, this.getPrevProductId);
      this.setBtnDisable(nextBtn, this.getNextProductId);
      prevBtn.addEventListener(
        "click",
        () => {
          this.handlePrevBtn(prevBtn);
        },
        true
      );
      nextBtn.addEventListener(
        "click",
        () => {
          this.handleNextBtn(nextBtn);
        },
        true
      );
    },
    DeleteUrls(track_ids, product_id) {
      let mytracks = [];
     // console.log("my test", track_ids);
      for (let s = 0; s < track_ids.length; s++) {
        for (let i = 0; i < track_ids[s].sellers.length; i++) {
          //  alert(track_ids[s].sellers[i].track_id);
          //  for (let k = 0; k < track_ids[s].sellers[i].length; k++) {
         
          mytracks.push(track_ids[s].sellers[i].track_id);
          //  }
        }
      }
     // console.log("my secovd test", this.product["product_domains"]);
   

      let data = {
        product_id: product_id,
        track_ids: mytracks,
      };
     
      this.$store
        .dispatch("productModule/deleteProductTracks", data)
        .then((res) => {
          if (!res.data.error) {
            // this.deleteDuplicateProduct(data.conflict)
            alert("Success");
            const array_of_ids_for_delete = track_ids.map(x => x.url_id);
            this.product["product_domains"].forEach(element => {
              // reverse splice
              for(let i = element.domain_urls.length-1; i >= 0; i--){
                if(array_of_ids_for_delete.includes( element.domain_urls[i].url_id )){
                  element.domain_urls.splice( i, 1 )
                }
              }
            });
            this.product["product_domains"] = this.product["product_domains"].filter(x => x.domain_urls.length > 0);
            // old code stays for testing
            // for (let mylink = 0; mylink <track_ids.length; mylink++) {
            //   let domainIdSearchValue =track_ids[mylink].url         
            //   for (let myd = 0; myd < this.product["product_domains"].length; myd++) {
              
                
            //     const domainIdIndex = this.product["product_domains"][
            //       myd
            //     ].domain_urls.findIndex((item) => item.url === domainIdSearchValue);
            //     if (domainIdIndex > -1) {
            //       this.product["product_domains"][myd].domain_urls.splice(
            //         this.product["product_domains"][myd].domain_urls.indexOf(
            //           domainIdIndex
            //         ),
            //         1
            //       );
            //       if (this.product["product_domains"][myd].domain_urls.length == 0) {
            //         this.product["product_domains"].splice(myd, 1);
            //       }
            //     }
            //   }
            // }
           // this.parentProduct(product_id)
          }
        });
      this.deleteDialog = false;
    },
    selectDomain(event, domain, prod_id) {
      this.$emit("selectSeller", event, domain, prod_id);
      console.log('newEmit')
      console.log('event', event)
      console.log('domain', domain)
      console.log('prod_id', prod_id)
      // if(event.target.checked){
      //   this.checkedUrls.push(...domain);
      // } else {
      //   domain.forEach(el => {
      //     if(1){
      //       let idx = 1;
      //     }
      //   })
      // }
      productDetailsBus.$emit(
        "selectDomain",
        event.target.checked,
        prod_id,
      );
    },
    selectSingleUrl( status, link ,prod_id) {
      console.log( 'event', event);
      console.log( 'link', link);
      console.log( 'prod_id', prod_id);
      // this.checkedUrls = is_Checked ? temp_domain_urls : [];
      productDetailsBus.$emit(
        "selectSingleUrl",
        status, link, prod_id
      );
    },
    
  },
  updated() {
    this.updateFooterButtonsListeners();
    let temp_domain_urls = [];
    let temp_track_ids = [];
    let temp_url_ids = [];
    // sortedArray = product["product_domains"].sort
    this.sortedArray.forEach((product_domain) => {
      product_domain.domain_urls.forEach((domain_url) => {
        temp_domain_urls.push(domain_url);
        temp_url_ids.push(domain_url.url_id);
        domain_url.sellers.forEach((seller) => {
          temp_track_ids.push(seller.track_id);
        });
      });
      // temp_domain_urls.push(...product_domain.domain_urls);
    });
    // pushing select all checkbox
    productDetailsBus.$on("selectAll", (is_Checked) => {
      console.log( is_Checked );
      this.checkedUrls = is_Checked ? temp_domain_urls : [];
      this.selectedAllFlag = is_Checked;
      productDetailsBus.$emit(
        "selectAll_ids",
        is_Checked,
        temp_track_ids,
        temp_url_ids
      );
    });
  },
  mounted() {
    console.log("product", this.product);
    this.$store.commit("productModule/SET_VISIBLE", true);
    // this.$store.commit("productModule/SET_SHOW", true);
    // this.$store.commit("productModule/SET_SEC_SHOW", true);
  },
  destroyed() {
    this.$store.commit("productModule/SET_VISIBLE", false);
    this.$store.commit("productModule/ADD_PRODUCT_CLIENT", []);
    this.updateFooterButtonsListeners();
  },
};
</script>

<style scoped>
#deleteButton {
  position: fixed;
  z-index: 9999;
}
#element1 {
  display: inline-block;
}

.total-product-data-table table > tbody > tr > td {
  padding-top: 15px !important;
}
.domain_title {
  margin: 0 auto;
}

.domain_section {
  padding: 15px 24px;
}

.domain_row_header {
  display: flex;
  width: 90%;
  justify-content: space-between;
  padding-right: 15px;
  align-items: center;
}

.domain_row_header_variation {
  width: 15%;
}

.domain_row_header_url {
  width: 70%;
  padding-bottom: 4px;
  overflow: hidden;
  overflow-x: auto;
  display: flex;
  align-items: center;
}

.domain_row_header_checkbox {
  width: 15%;
}

.domain_row_header_url::-webkit-scrollbar-track {
  background-color: #616161;
}

.domain_row_header_url::-webkit-scrollbar {
  height: 3px;
}

.domain_row_header_url::-webkit-scrollbar-button {
  display: none;
}

.domain_row_header_url::-webkit-scrollbar-thumb {
  background-color: #b0b0b0;
}

.link_text {
  font-size: 14px;
  white-space: nowrap;
}

table tr td {
  position: relative;
}

.tableHeaderClass span {
  font-weight: 300;
  color: #9899ac;
  font-size: 14px;
  display: block;
  margin-top: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/product/ProductDetailsTable.vue